import { render, staticRenderFns } from "./DashBoardConfiguration.vue?vue&type=template&id=3d5b528c&scoped=true"
import script from "./DashBoardConfiguration.vue?vue&type=script&lang=js"
export * from "./DashBoardConfiguration.vue?vue&type=script&lang=js"
import style0 from "./DashBoardConfiguration.vue?vue&type=style&index=0&id=3d5b528c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5b528c",
  null
  
)

export default component.exports